export const getOwnProfile = () => ({
  person: {
    id: 'sdo-mdfonjmasd-nmdgvpndpvn2135-35m-95smso',
    nativeGivenName: 'John',
    nativeFamilyName: 'Snow',
    birthDate: '1990-07-20',
    age: 31,
    birthYear: 0,
    tennisID: 'TES123456',
    nationalID: '',
    sex: 'M',
    nationalityCode: 'ITA',
    optedOutOfPublicDataConsent: false,
    isRanked: false,
    eligibleForSelfSubmission: true,
    eligibleForPsq: true,
    biographicalInformation: {
      placeOfResidence: 'GBR',
      playingHand: '',
      doublePlayingHand: '',
      weightInKgs: 79.2,
      heightInMeters: 1.79,
      avatarUrl:
        'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
      favouriteShot: '',
      __typename: 'BiographicalInformation',
    },
    worldTennisNumbers: [
      {
        type: 'DOUBLE',
        tennisNumber: 24.81,
        confidence: 0.6,
        __typename: 'WorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 24.02,
        confidence: 0.7,
        __typename: 'WorldTennisNumber',
      },
    ],
    __typename: 'Person',
  },
})
